export default __webpack_public_path__ + "static/media/powered-by-strava.45a6b086.svg";